<template>
	<div :class="['layout-feedback', {'layout-feedback--open': showDialog}]">
		<a v-if="!showDialog" href="#" class="layout-feedback--button" @click.prevent="showDialog = true">
			<Icon icon="mail"/>
			Feedback
		</a>
		<div v-else class="layout-feedback--dialog">
			<header>
				<div>Fragen oder Anregungen? Wir freuen uns auf Feedback!</div>
				<div>
					<a href="#" @click.prevent="showDialog = false">
						<Icon icon="close"/>
					</a>
				</div>
			</header>
			<main>
				<b-input v-if="!isLoggedIn" v-model.trim="email" placeholder="E-Mail"/>
				<b-textarea v-model="message" :rows="6" placeholder="Deine Nachricht..."/>
				<div class="button-container">
					<Button
						text="Senden"
						icon="checkmark"
						:disabled="!dataValid || sending"
						:loading="sending"
						@click="send"
					/>
				</div>
			</main>
			<footer>
				<Icon icon="mail"/>
				Feedback
			</footer>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import Button from "@/vue/common/Button.vue";
import {isEmptyOrNull} from "@/helper/String";
import {mapGetters} from "vuex";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Send from "@/api/feedback/Send";
import * as EmailValidator from "email-validator";
import EventBus from "@/event/EventBus";
import * as Event from "@/event/Event";
import {getQueryParams, removeQueryParamsFromUrl} from "@/helper/Url";

export default {
	components: {Button, Icon},

	data ()
	{
		return {
			email: '',
			message: '',
			showDialog: false,
			sending: false
		};
	},

	mounted ()
	{
		const queryParams = getQueryParams();


		if (queryParams.feedbackOpen)
		{
			this.showDialog = true;

			removeQueryParamsFromUrl();
		}

		EventBus.$on(Event.SHOW_FEEDBACK, () =>
		{
			this.showDialog = true;
		});
	},

	computed: {
		...mapGetters('auth', [
			'isLoggedIn'
		]),
		emailValid ()
		{
			return this.isLoggedIn
				|| (!isEmptyOrNull(this.email) && EmailValidator.validate(this.email));
		},
		messageValid ()
		{
			return !isEmptyOrNull(this.message);
		},
		dataValid ()
		{
			return this.emailValid && this.messageValid;
		},
	},

	methods: {
		async send ()
		{
			this.sending = true;

			try
			{
				await new Send()
					.setEmail(
						!this.isLoggedIn
							? this.email
							: undefined
					)
					.setMessage(this.message)
					.setUrl(location.pathname)
					.call();

				this.message = '';
				this.showDialog = false;

				Toast.success(this, ['Vielen Dank für dein Feedback!']);
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sending = false;
		}
	}
}
</script>
